import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import axios from "axios";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {useNavigate } from "react-router-dom";

export default function MyDynamicClassModal({ event, cancelModal, refresh }) {
  //styled

  const [bookings, setBookings] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [cancelClass, setCancelClass] = useState(false);
  const [cancelClassComplete, setCancelClassComplete] = useState(false);
  const [cancelBooking, setCancelBooking] = useState(false);
  const [cancelBookingComplete, setCancelBookingComplete] = useState(false);
  const { user } = useAuthContext();
  const navi = useNavigate();

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const bookingResponse = await axios.get(
        `${ApiConnectionString}/api/BookingsByEvent/${
          event.id
        }/${event.oneOffDate.substring(0, 10)}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setBookings(bookingResponse.data);
    } catch (error) {
      console.error("Error fetching the event or bookings:", error);
      // Optionally, you could set an error state or notify the user here
    } finally {
      // Always set loading to false after fetching data
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [user]);

  const handleCancelBooking = async () => {
    const response = await axios.delete(
      `${ApiConnectionString}/api/Booking/${selectedBooking.id}`,
      {
        headers: { Authorization: `bearer ${user.token}` },
      }
    );

    if (response.status == 200) {
      setCancelBookingComplete(true);
      fetchData();
    }
  };

  const handleCancelClass = async () => {
    const cancelEvent = {
      eventId: event.id,
      date: event.oneOffDate.substring(0, 10),
    };
    const cancelResponse = await axios.post(
      `${ApiConnectionString}/api/cancelEvent`,
      cancelEvent,
      {
        headers: { Authorization: `bearer ${user.token}` },
      }
    );
    if (cancelResponse.status == 200) {
      setCancelClass(false);
      setCancelClassComplete(true);
      fetchData();
    }
  };

  if (isLoading) {
    <div className="send-modal-overlay">
      <div className="send-modal">
        <LoadingSpinner />
        <div className="send-modal-footer"></div>
      </div>
    </div>;
  } else {
    if (cancelBookingComplete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Booking Canceled</p>
            </div>
            <p>Booking has been successfully canceled.</p>

            <div className="send-modal-footer">
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={() => {
                  setCancelBooking(false);
                  setCancelBookingComplete(false);
                }}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      );
    }
    if (cancelClassComplete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Class Canceled</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <p>The class has been successfully canceled.</p>

            <div className="send-modal-footer">
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else if (cancelClass) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Cancel Class</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <table>
              <tbody>
                {/* <tr>
                  <td className="red-text fw-bold">User:</td>
                  <td>{selectedBooking.viewBookingProfile.username}</td>
                </tr>
                <tr>
                  <td className="red-text fw-bold">Class:</td>
                  <td>{selectedBooking.viewEvent.name}</td>
                </tr>
                <tr>
                  <td className="red-text fw-bold">Time:</td>
                  <td>
                    {selectedBooking.viewEvent.timeIn} -{" "}
                    {selectedBooking.viewEvent.timeOut}
                  </td>
                </tr>
                <tr>
                  <td className="red-text fw-bold">Date:</td>
                  <td>{selectedBooking.date.substring(0, 10)}</td>
                </tr> */}
              </tbody>
            </table>

            <p>Are you sure you want to cancel this class?</p>

            <div className="send-modal-footer">
              <button
                className="saveChanges-button mx-3"
                onClick={handleCancelClass}
              >
                {" "}
                Confirm
              </button>
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={() => setCancelClass(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    } else if (cancelBooking) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Cancel Booking</p>
            </div>
            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <table>
              <tbody>
                <tr>
                  <td className="red-text fw-bold">User:</td>
                  <td>{selectedBooking.viewBookingProfile.username}</td>
                </tr>
                <tr>
                  <td className="red-text fw-bold">Class:</td>
                  <td>{selectedBooking.viewEvent.name}</td>
                </tr>
                <tr>
                  <td className="red-text fw-bold">Time:</td>
                  <td>
                    {selectedBooking.viewEvent.timeIn} -{" "}
                    {selectedBooking.viewEvent.timeOut}
                  </td>
                </tr>
                <tr>
                  <td className="red-text fw-bold">Date:</td>
                  <td>{selectedBooking.date.substring(0, 10)}</td>
                </tr>
              </tbody>
            </table>{" "}
            <p>Are you sure you want to cancel this booking?</p>
            <div className="send-modal-footer">
              <button
                className="delete-button mx-3"
                onClick={handleCancelBooking}
              >
                Confirm
              </button>

              <button
                onClick={() => setCancelBooking(false)}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="container">
              <div className="blueBanner">
                <p className="fw-bold m-2 p-2 fontSize20">{event.name}</p>
              </div>

              <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>

              <table>
                <tbody>
                  <tr>
                    <td className="red-text fw-bold">Day:</td>
                    <td>{event.day}</td>
                  </tr>
                  <tr>
                    <td className="red-text fw-bold">Times:</td>
                    <td>
                      {event.timeIn} - {event.timeOut}
                    </td>
                  </tr>
                  <tr>
                    <td className="red-text fw-bold">Date:</td>
                    <td>{new Date(event.oneOffDate).toLocaleDateString()}</td>
                  </tr>
                </tbody>
              </table>

              <div className="d-flex justify-content-between my-2">
                {" "}
                <button
                  className="saveChanges-button"
                  onClick={() =>
                    navi(
                      `/BookThemIntoMyClass/${
                        event.id
                      }/${event.oneOffDate.substring(0, 10)}`
                    )
                  }
                >
                  Book someone into this class
                </button>
                <button
                  className="delete-button"
                  onClick={() => setCancelClass(true)}
                >
                  Cancel Class
                </button>
              </div>
              <hr></hr>
              <div>
      {bookings.length > 0 ?          <div className="lightBlueBanner">
                  {" "}
                  <p className="fw-bold p-2">Bookings</p>
                </div> : <p>No one has booked this class yet.</p>
              }

                <ul>
                  {bookings.map((booking) => (
                    <li
                      key={booking.id}
                      style={{
                        display: "flex",
                      }}
                    >
                      <span>{booking.viewBookingProfile.username}</span>

                      <Dropdown>
                        <Dropdown.Toggle
                          as="span"
                          id="dropdown-custom-components"
                          className="dropdown-toggle-custom"
                        >
                          <ThreeDotsVertical
                            style={{ cursor: "pointer" }}
                            onClick={() => setSelectedBooking(booking)}
                          />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            eventKey="2"
                            onClick={() => {
                              setCancelBooking(true);
                            }}
                          >
                            Cancel this booking
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="send-modal-footer">
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
